import React, { useState } from "react";
import styled from "styled-components";
import { BlockProps } from "./Block.types";
import TileDown from "../../assets/UI/TileDown.png";
import TileWin from "../../assets/UI/TileWin.png";
import TileLose from "../../assets/UI/TileLose.png";
import TileRevealBomb from "../../assets/UI/TileRevealBomb.png";
import TileRevealGem from "../../assets/UI/TileRevealDiamond.png";

import { PlayAudio, emitGameAction } from "@lindar-joy/goosicorn-quickies-library";
import ExplosionEffects from "../Explosion/ExplosionEffects";

const BlockContainer = styled.div`
    aspect-ratio: 1;
    max-width: 116px;
    max-height: 116px;
`;

const BaseBlock = styled.div`
    background-image: url(${TileDown});
    background-size: cover;
    pointer-events: none;
    width: 100%;
    height: 100%;
`;

const DefaultBlock = styled(BaseBlock)`
    background-image: url(${TileDown});
`;

const GemBlock = styled(BaseBlock)`
    background-image: url(${TileWin});
`;

const BombBlock = styled(BaseBlock)`
    background-image: url(${TileLose});
`;

const RevealedBombBlock = styled(BaseBlock)`
    background-image: url(${TileRevealBomb});
`;

const RevealedGemBlock = styled(BaseBlock)`
    background-image: url(${TileRevealGem});
`;

const UncoveredBlock = styled(DefaultBlock)`
    outline: 1px solid var(--accent);
    border-radius: 16px;
    cursor: pointer;
    pointer-events: initial;
`;

const Block: React.FC<BlockProps> = ({
    id,
    bet,
    mineCount,
    explosion,
    onClick,
    ...props
}) => {
    return (
        <div>
            <BlockContainer {...props}>
                { props.type === "DEFAULT" && <DefaultBlock></DefaultBlock> }
                { props.type === "NON_DISCOVERED" && <UncoveredBlock onClick={onClick}></UncoveredBlock> }
                {/* { props.type === "GEM" && <GemBlock></GemBlock> } */}
                {/* { props.type === "BOMB" && <Explosion id={id.toString()}></Explosion> } */}
                { props.type === "REVEALED_BOMB" && <RevealedBombBlock></RevealedBombBlock> }
                { props.type === "REVEALED_GEM" && <RevealedGemBlock></RevealedGemBlock> }
            </BlockContainer>
        </div>
    );
};

export default Block;